<template>
  <div>
    <ui-heading tag="h5">
      {{ $t("companyProcedures.important.title") }}
    </ui-heading>
    <div v-if="importants.length">
      <section-item
        v-if="isProhibited"
        :item-name="$t('companyProcedures.important.isProhibited')"
      />
      <div
        v-else
        v-for="(item, index) in importants"
        :key="`important_${index}`"
      >
        <section-item
          v-if="
            item[IMPORTANTS_FIELDS.RULE] !==
              IMPORTANT_RULE.HAS_PROHIBITED_COUNTRIES ||
            (item[IMPORTANTS_FIELDS.RULE] ===
              IMPORTANT_RULE.HAS_PROHIBITED_COUNTRIES &&
              isEmpty(countryFilterCode))
          "
          :item-name="translateImportantRule(item.rule)"
        />
        <select
          v-if="
            item[IMPORTANTS_FIELDS.RULE] ===
              IMPORTANT_RULE.HAS_PROHIBITED_COUNTRIES &&
            item[IMPORTANTS_FIELDS.COUNTRIES_ISO_2] &&
            isEmpty(countryFilterCode)
          "
          class="prohibited-list"
          :size="getSelectSize(item[IMPORTANTS_FIELDS.COUNTRIES_ISO_2].length)"
          :tabindex="-1"
        >
          <option
            v-for="(countryCode, index) in item[
              IMPORTANTS_FIELDS.COUNTRIES_ISO_2
            ]"
            :key="index"
            class="country-list-item"
            disabled
          >
            {{
              $t(`countries.${countryCodes[countryCode]}`) + ` (${countryCode})`
            }}
          </option>
        </select>
        <select
          v-if="
            item[IMPORTANTS_FIELDS.RULE] ===
              IMPORTANT_RULE.HAS_PROHIBITED_NATIONALITIES &&
            item[IMPORTANTS_FIELDS.COUNTRIES_ISO_2]
          "
          class="prohibited-list"
          :size="getSelectSize(item[IMPORTANTS_FIELDS.COUNTRIES_ISO_2].length)"
          :tabindex="-1"
        >
          <option
            v-for="(countryCode, index) in item[
              IMPORTANTS_FIELDS.COUNTRIES_ISO_2
            ]"
            :key="index"
            class="country-list-item"
            disabled
          >
            {{
              $t(`countries.${countryCodes[countryCode]}`) + ` (${countryCode})`
            }}
          </option>
        </select>
        <textarea
          v-if="
            item[IMPORTANTS_FIELDS.RULE] ===
              IMPORTANT_RULE.ADDITIONAL_REGISTRATION_VALIDATION_REQUIRED &&
            item[IMPORTANTS_FIELDS.ADDITIONAL_REGISTRATION_VALIDATION_RULE]
          "
          :value="
            item[IMPORTANTS_FIELDS.ADDITIONAL_REGISTRATION_VALIDATION_RULE]
          "
          disabled
          :tabindex="-1"
        />
      </div>
    </div>
    <div v-else>
      -
    </div>
  </div>
</template>
<script>
import { IMPORTANT_RULE, IMPORTANTS_FIELDS } from "../../constants";
import countryCodes from "../../assets/isoCodes.json";
import { getSelectSize, isEmpty, translateImportantRule } from "./utils";
import SectionItem from "./SectionItem";

export default {
  components: { SectionItem },
  props: {
    isProhibited: { type: Boolean, default: false },
    importants: { type: Array, default: null },
    countryFilterCode: { type: String, default: null }
  },
  data() {
    return {
      IMPORTANTS_FIELDS,
      IMPORTANT_RULE,
      countryCodes
    };
  },

  methods: {
    translateImportantRule,
    isEmpty,
    getSelectSize
  }
};
</script>
<style scoped>
textarea {
  width: 80%;
  padding: 0.5rem;
  margin: 1rem 0 0 1.5rem;
  resize: vertical;
}

.prohibited-list {
  margin-left: 1.5rem;
}
</style>
